/**
 * Shared helpers for normalizing chat messages from API responses.
 * Used by both chatApi.ts (companion) and williamsApi.ts (Williams).
 */

import type { ChatMessageState } from '@/types/chat';

export interface RawMessage {
  id: string;
  role: 'user' | 'assistant' | 'system' | 'trfer';
  content: string;
  timestamp: string;
  agent?: string;
  metadata?: Record<string, unknown>;
}

export function normalizeRawMessage(msg: RawMessage): ChatMessageState {
  return {
    id: msg.id,
    role: msg.role,
    content: msg.content,
    timestamp: msg.timestamp,
    status: 'complete',
    metadata: {
      agent: msg.agent,
      ...msg.metadata,
    },
  };
}
